// Central test-ID registry for the Loadout homepage.
export const HOME = {
  // Legacy connection-page ids (kept — used by /connection)
  emergentLink: 'home-emergent-link',
  connectionBadge: 'home-connection-badge',
  connectionShopName: 'home-connection-shop-name',
  connectionError: 'home-connection-error',
  refreshButton: 'home-refresh-button',
  productsGrid: 'home-products-grid',
  productsCount: 'home-products-count',
  productsLoading: 'home-products-loading',
  productsError: 'home-products-error',
  productsEmpty: 'home-products-empty',

  // Homepage sections
  topUtilityBar: 'home-top-utility-bar',
  trackOrderLink: 'home-track-order-link',
  currencyChip: 'home-currency-chip',
  mainHeader: 'home-main-header',
  brandWordmark: 'home-brand-wordmark',
  navItem: 'home-nav-item',
  searchButton: 'home-search-button',
  cartButton: 'home-cart-button',
  discordLink: 'home-discord-link',

  heroSection: 'home-hero',
  heroHeadlineLine1: 'home-hero-headline-1',
  heroHeadlineLine2: 'home-hero-headline-2',
  heroSubhead: 'home-hero-subhead',
  heroCtaPrimary: 'home-hero-cta-primary',
  heroCtaSecondary: 'home-hero-cta-secondary',
  heroCarouselItem: 'home-hero-carousel-item',

  trustStrip: 'home-trust-strip',
  trustItem: 'home-trust-item',

  armorySection: 'home-armory',
  armoryTile: 'home-armory-tile',

  featuredDrop: 'home-featured-drop',
  featuredDropPrice: 'home-featured-drop-price',
  featuredDropCta: 'home-featured-drop-cta',

  proWall: 'home-pro-wall',
  proWallDeferred: 'PRO_SETUP_WALL',

  bestsellersSection: 'home-bestsellers',
  bestsellersViewAll: 'home-bestsellers-view-all',
  productCard: 'home-product-card',
  productTitle: 'home-product-title',
  productPrice: 'home-product-price',

  labSection: 'home-lab',
  labArticle: 'home-lab-article',
  labCta: 'home-lab-cta',

  assemblyStrip: 'home-assembly-strip',
  assemblyCta: 'home-assembly-cta',

  finalTrustBand: 'home-final-trust-band',
  footer: 'home-footer',

  // PROMPT 3.0 — Community Loadouts
  communitySection: 'home-community',
  communityEyebrow: 'home-community-eyebrow',
  communityHeadline: 'home-community-headline',
  communitySubhead: 'home-community-subhead',
  communityGrid: 'home-community-grid',
  communityCard: 'home-community-card',
  communityLoading: 'home-community-loading',
  communitySentinel: 'home-community-sentinel',
  communityLightbox: 'home-community-lightbox',
  communityShopLink: 'home-community-shop-link',

  // PROMPT 3.0 — Warranty Strip
  warrantyStrip: 'home-warranty-strip',
  warrantyEyebrow: 'home-warranty-eyebrow',
  warrantyHeadline: 'home-warranty-headline',
  warrantySubhead: 'home-warranty-subhead',
  warrantyCta: 'home-warranty-cta',

  // PROMPT 3.0 — configurator quiz
  quizOpenHero: 'home-quiz-open-hero',
  quizOpenNav: 'home-quiz-open-nav',
  heroRail: 'home-hero-rail',
  quizModal: 'home-quiz-modal',
  quizClose: 'home-quiz-close',
  quizCategoryChips: 'home-quiz-category-chips',
  quizBudgetSlider: 'home-quiz-budget-slider',
  quizBudgetValue: 'home-quiz-budget-value',
  quizNext: 'home-quiz-next',
  quizBack: 'home-quiz-back',
  quizRestart: 'home-quiz-restart',
  quizResultsGrid: 'home-quiz-results-grid',
  quizResultCard: 'home-quiz-result-card',
  quizAddAllToCart: 'home-quiz-add-all-to-cart',
  quizShareLoadout: 'home-quiz-share-loadout',
  quizEmptyState: 'home-quiz-empty-state',

  // Footer company column
  footerCompanyColumn: 'home-footer-company-column',
  footerCompanySupportEmail: 'home-footer-company-support-email',
  footerCompanySupportHours: 'home-footer-company-support-hours',
  footerCompanyResponsePromise: 'home-footer-company-response-promise',
  footerCompanyGstin: 'home-footer-company-gstin',
  footerCompanyCin: 'home-footer-company-cin',
  footerCompanyAddress: 'home-footer-company-address',
};
